import FeatureSettingsApi from '@/api/featureSettings'
import Sentry from '@/services/sentry'
import { trackFeatureSettings } from '@/business-logic/ai-tracking'

const SET_FEATURE_SETTINGS = 'SET_FEATURE_SETTINGS'

const _state = {
  featureSettings: {},
  isFeatureSettingsLoaded: false,
}

const _getters = {
  isFeatureDisabled: (state, getters, rootState, rootGetters) => (featureName) => {
    const canUseAIConsentSettings = rootGetters['featureToggles/canUseAIConsentSettings']
    if (!canUseAIConsentSettings) return false
    const feature = state.featureSettings[featureName]
    return feature ? feature.isDisabled : false
  },
  featureDisabledReason: (state, getters, rootState, rootGetters) => (featureName) => {
    const canUseAIConsentSettings = rootGetters['featureToggles/canUseAIConsentSettings']
    if (!canUseAIConsentSettings) return null
    const feature = state.featureSettings[featureName]
    return feature ? feature.disabledReason : null
  },
  isFeatureSettingsLoaded: (state) => state.isFeatureSettingsLoaded,
}

const actions = {
  async fetchFeatureSettings({ commit, rootGetters }) {
    const canUseAIConsentSettings = rootGetters['featureToggles/canUseAIConsentSettings']
    if (!canUseAIConsentSettings) {
      // Feature flag off — skip fetch, all features enabled
      commit(SET_FEATURE_SETTINGS, {})
      return
    }
    try {
      trackFeatureSettings({ stage: 'started' })
      const featureSettings = await FeatureSettingsApi.getFeatureSettings()
      commit(SET_FEATURE_SETTINGS, featureSettings)
    } catch (e) {
      Sentry.captureException(e)
      trackFeatureSettings({ stage: 'failed', error: e })
      // Fail-open: mark as loaded with empty settings (all features enabled)
      commit(SET_FEATURE_SETTINGS, {})
    }
  },
}

const mutations = {
  // eslint-disable-next-line no-param-reassign
  [SET_FEATURE_SETTINGS](state, featureSettings) {
    state.featureSettings = featureSettings // eslint-disable-line no-param-reassign
    state.isFeatureSettingsLoaded = true // eslint-disable-line no-param-reassign
  },
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
}
